"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.selectDropdownTypes = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconLabel = require("../../IconLabel/IconLabel");
var _Text = require("../../Text/Text");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable import/prefer-default-export */
/* eslint react/forbid-prop-types: 0 */

const selectDropdownTypes = exports.selectDropdownTypes = {
  MenuHeader: ({
    text,
    open
  }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLabel.IconLabel, {
    id: "dropdown-header",
    leftIcon: {
      color: 'interactive',
      rotate: '',
      size: 'sm',
      type: 'sort'
    },
    rightIcon: {
      color: 'interactive',
      size: 'sm',
      type: 'expand-more',
      rotate: open ? '180' : ''
    },
    text: text
  }),
  ValueHeader: ({
    open,
    text,
    selection
  }) => {
    var _selection$Object$get;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLabel.IconLabel, {
      id: "dropdown-header",
      rightIcon: {
        color: 'interactive',
        rotate: open ? '180' : '',
        size: 'sm',
        type: 'expand-more'
      },
      text: ((_selection$Object$get = selection[Object.getOwnPropertyNames(selection).shift()]) == null ? void 0 : _selection$Object$get.text) || text,
      lblContainerCssModifier: "inline"
    });
  },
  CheckOption: ({
    isSelected,
    text
  }) => isSelected ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLabel.IconLabel, {
    id: "dropdown-option",
    leftIcon: {
      color: 'interactive',
      size: 'sm',
      type: 'check'
    },
    text: text,
    lblContainerCssModifier: "inline"
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLabel.IconLabel, {
    id: "dropdown-option",
    leftIcon: {
      color: '',
      size: 'sm',
      type: 'empty-space'
    },
    text: text,
    lblContainerCssModifier: "inline"
  }),
  SimpleText: ({
    text
  }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
    content: text,
    type: "small-body-text"
  }),
  External: ({
    text
  }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLabel.IconLabel, {
    id: "dropdown-option",
    rightIcon: {
      color: 'interactive',
      size: 'sm',
      type: 'linkout'
    },
    text: text,
    lblContainerCssModifier: "inline"
  })
};